import { coursesTypes } from '../../reducers/types';

export default () => ({
  type: coursesTypes.SET_COURSE,
  payload: {},
});
